//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import TreeView from "eai-configurator-ui/components/base/TreeView";
import Paper from "@material-ui/core/Paper";
import ErrorMessageDialog, {useErrorMessageDialog,} from "eai-configurator-ui/components/configuration/dialog/ErrorMessageDialog";
import XmlExtractButton from "src/components/loader/buttons/XmlExtractButton";
import ConfigurationComboBox from "eai-configurator-ui/components/configuration/base/ConfigurationComboBox";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  textField: {
    width: "100%",
  },
  error: {
    color: "red",
  },
  checkbox: {
    paddingLeft: 0,
  },
  paper: {
    padding: 10,
  },
  button: {
    margin: 4,
  },
  expandablePanelIcon: {
    margin: 4,
  },
  expandablePanel: {
    paddingLeft: 10,
  },
}));
const XmlExtractPage = ({navigateToResults}) => {
  const classes = useStyles();
  const [errorMessage, setErrorMessage] = useErrorMessageDialog();

  return (
    <React.Fragment>
      <div>
        <Typography variant="body2" color="textSecondary">
          <h5>Extract from P6 into XML/ ZIP files</h5>
          <hr/>
        </Typography>

        <Box m={1} display="flex" flexDirection="row" justifyContent="flex-end">
          <XmlExtractButton
            className={classes.button}
            handleSuccess={navigateToResults}
          />
        </Box>

        <div>
          <ErrorMessageDialog {...errorMessage} />
          <Paper className={classes.paper}>
            <Typography variant="body2" color="textSecondary">
              <h6>Extration Options</h6>
            </Typography>
            <ConfigurationComboBox path={"loader:xmlExtract:includeBaselines"}/>
            <ConfigurationComboBox path={"loader:xmlExtract:exportFormat"}/>
            <Typography variant="body2" color="textSecondary">
              <h6>Select the Projects to Extract</h6>
            </Typography>
            <div className={classes.paper}>
              <Grid
                container
                spacing={1}
                justify="center"
                className={classes.root}
                alignItems="flex-start"
              >
                <Grid item xs={10}>
                  <TreeView
                    allowRefresh={true}
                    path={"loader:xmlExtract:projects"}
                    url={"loader/epsTree"}
                  />
                </Grid>
              </Grid>
            </div>
          </Paper>
        </div>
      </div>
    </React.Fragment>
  );
};
export default XmlExtractPage;
